
import { useEffect, useRef, useState } from "react";
import { Form, Input, Button, Card, Select, DatePicker, Spin, Alert, message   } from "antd";
import { agregarUsuario } from '../api/participantesApi';
import { useNavigate } from "react-router-dom";

  const AgregarParticipantes = () => {
  const { Option } = Select;
  const navigate = useNavigate();
  const [guardando, setGuardando] = useState(false);
  const [errorGuardar, setErrorGuardar] = useState("");
  const guardadoEnCurso = useRef(false);
  const handleCancel = () => {
    navigate("/participantes");
  };
    
  const [form] = Form.useForm();
    useEffect(() => {
  }, []);

  const onFinish = async (values) => {
    if (guardadoEnCurso.current) return;

    guardadoEnCurso.current = true;
    setGuardando(true);
    setErrorGuardar("");
    try {
      const datosEnviar = {
        ...values,
        nacimiento: values.nacimiento
          ? values.nacimiento.format("YYYY-MM-DD")
          : null 
      };
      console.log("Datos a enviar:", datosEnviar);
      const resultado = await agregarUsuario(datosEnviar);
      if (resultado.inscrito) {
          message.success("¡Participante Agregado correctamente!");

          navigate("/participantes");
      } else {
          setErrorGuardar(resultado.error || "No se pudo inscribir al participante.");
      }
    } catch (error) {
          console.error("Error al guardar:", error);
          setErrorGuardar(error.response?.data?.error || "No se pudo guardar al participante. Intenta nuevamente.");
    } finally {
      guardadoEnCurso.current = false;
      setGuardando(false);
    }
  };

  return (
    <div
        style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        background: "#f5f5f5"
    }}
    >
      <Spin
        spinning={guardando}
        fullscreen
        size="large"
        tip={<span role="status">Guardando participante…</span>}
      />

      <Card title="" style={{ maxWidth: 850, width: "100%" }}>
        <h2>Agregar Participante</h2>
        {errorGuardar && (
          <Alert
            type="error"
            showIcon
            title={errorGuardar}
            role="alert"
            style={{ marginBottom: 16 }}
          />
        )}
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        htmlType="submit"
       
      >
        <Form.Item
          label="Nombre"
          name="nombre"
          rules={[
            { required: true, message: "El nombre es obligatorio" }
          ]}
        >
          <Input placeholder="Nombre" />
        </Form.Item>

        <Form.Item
          label="Apellidos"
          name="apellidos"
          rules={[
            { required: true, message: "Los apellidos son obligatorios" }
          ]}
        >
        <Input placeholder="Apellidos" />
        </Form.Item>

        <Form.Item>
        
        <Form.Item
            label="Talla"
            name="talla"
            rules={[
                { required: true, message: "La talla es obligatoria" }
            ]}
        >

        <Select placeholder="Selecciona una talla">
            <Option value="Ninguna">Ninguna</Option>
            <Option value="Extrachica">Extrachica</Option>
            <Option value="Chica">Chica</Option>
            <Option value="Mediana">Mediana</Option>
            <Option value="Grande">Grande</Option>
            <Option value="Extragrande">Extragrande</Option>
        </Select>
        </Form.Item>

        <Form.Item
            label="Categoria"
            name="categoria"
            rules={[
                { required: true, message: "La categoria es obligatoria" }
            ]}
        >
        <Select placeholder="Selecciona una Categoría">
            <Option value="Juvenil">Juvenil (19 años o menos)</Option>
            <Option value="Libre">Libre (20-39 años)</Option>
            <Option value="Master">Máster (40-49 años)</Option>
            <Option value="Veteranos">Veteranos (50-59 años)</Option>
            <Option value="Veteranosplus">Veteranos Plus (60 en adelante)</Option>
            <Option value="MEDICOVeteranosfemenil">Médicos Femenil (Hasta 44 años)</Option>
            <Option value="MEDICOVeteranosvaronil">Médicos Varonil (Hasta 49 años)</Option>
            <Option value="MEDICOVeteranosvaronilplus">Médicos Varonil (50 años en adelante)</Option>
            <Option value="MEDICOVeteranosfemenilplus">Médicos Femenil (45 años en adelante)</Option>
        </Select>
        </Form.Item>

        <Form.Item
            label="Fecha de nacimiento"
            name="nacimiento"
            rules={[{ required: true, message: "La fecha es obligatoria" }]}
            >
            <DatePicker
                style={{ width: "100%" }}
                format="DD/MM/YYYY"
            />
        </Form.Item>

        <Form.Item
          label="Télefono"
          name="telefono"
          rules={[
            { required: true, message: "El Télefono es obligatorio" }
          ]}
        >
        <Input placeholder="Télefono" />
        </Form.Item>
          <Form.Item
          label="Correo"
          name="email"
          rules={[
            { required: true, message: "El correo es obligatorio" },
            { type: "email", message: "Ingresa un correo válido" }
         ]}
        >
        <Input placeholder="Correo" />
        </Form.Item>

        <Form.Item
            label="Sexo"
            name="sexo"
            rules={[
                { required: true, message: "Selecciona un Sexo" }
            ]}
        >

        <Select placeholder="Selecciona un sexo">
            <Option value="Hombre">Hombre</Option>
            <Option value="Mujer">Mujer</Option>
        </Select>
        </Form.Item>    

        <Button
        type="primary"
        loading={guardando}
        disabled={guardando}
        htmlType="submit"
        style={{ marginRight: 10 }}
        >
        Guardar
        </Button>

        <Button 
            disabled={guardando}
            onClick={handleCancel} 
            style={{
                backgroundColor: "#ff4d4f",
                borderColor: "#ff4d4f",
                color: "#fff"
            }}
        >
        Cancelar
        </Button>
        </Form.Item>
      </Form>
    </Card>
    </div>
  );
};

export default AgregarParticipantes;
